import { capitalizeSentences } from '@utils';

const convertCategoryName = (str, upper) => {
    if (str === 'tum-urunler') {
        return 'Tüm Ürünler';
    }
    if (str === 'yilbasi') {
        return 'Yılbaşı';
    }
    if (str === 'uzun elbiseler') {
        return 'Uzun Elbiseler';
    }
    if (str === 'discounts') {
        return 'Sale';
    }
    if (str === 'plus size dresses') {
        return 'Plus Size';
    }
    if (str === 'buyuk-beden') {
        return 'Büyük Beden';
    }
    if (str === 'bottoms') {
        return 'Bottoms';
    }
    if (str === 'tops') {
        return 'Tops';
    }
    if (str === 'ustler') {
        return 'Üstler';
    }
    if (str === 'bunny') {
        return 'Bunny';
    }
    if (str === 'goat') {
        return 'G.O.A.T';
    }
    if (upper) return capitalizeSentences(str.replace(/-/g, ' '));

    return str;
};
export default convertCategoryName;
